export default {
  resorder_issue_details: "Order Issue Details",
  resback_to_orders: "Back to Orders",
  resissue_report_id: "Issue Report ID",
  resreported_on: "Reported on",

  resissue_information: "Issue Information",
  resissue_type: "Issue Type",
  resmissing_items: "Missing Items",
  resdamaged_items: "Damaged Items",
  resdamaged_products:"Damaged Products",
  reswrong_items: "Wrong Items",

  resselect_product: "Select product",
  resdescription: "Description",
  resdescribe_issue: "Describe the issue...",

  resadd_photos: "Add Photos",
  ressubmit_issue: "Submit Issue",

  ressupplier_response: "Supplier Response",
  resaction: "Action",
  resrefund: "Refund",
  resnotes: "Notes",

  resrecent_activity: "Recent Activity",
  resissue_reported: "Issue Reported",
  resissue_under_review: "Issue Under Review",
  reswaiting_supplier: "Waiting for supplier response",
  resissue_resolved: "Issue Resolved",

  resneed_help: "Need Help?",
  rescontact_support: "Contact Support",

  resdescribe_issue_error: "Please describe the issue",
  resselect_product_error: "Please select at least one product",
  resissue_failed: "Failed to report issue",
};